import Phaser from 'phaser'

export const GAME_WIDTH = 800
export const GAME_HEIGHT = 600

// Player configuration
export const PLAYER_CONFIG = {
  width: 60,
  height: 40,
  speed: 300,
  color: 0x00ff00,
  startLives: 3,
  respawnDelay: 1500,
  invincibilityTime: 2000,
}

// Invader type definitions with classic pixel patterns
// Each type has 2 animation frames (pattern1 and pattern2)
export const INVADER_TYPES = [
  {
    // Top row - Squid type (highest points)
    key: 'invader_squid',
    color: 0xff0000,
    points: 30,
    width: 32,
    height: 32,
    pattern1: [
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 1, 1, 1, 1, 0, 0],
      [0, 1, 1, 1, 1, 1, 1, 0],
      [1, 1, 0, 1, 1, 0, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 1, 0, 0, 1, 0, 0],
      [0, 1, 0, 1, 1, 0, 1, 0],
      [1, 0, 1, 0, 0, 1, 0, 1],
    ],
    pattern2: [
      [0, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 1, 1, 1, 1, 0, 0],
      [0, 1, 1, 1, 1, 1, 1, 0],
      [1, 1, 0, 1, 1, 0, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1],
      [0, 1, 0, 1, 1, 0, 1, 0],
      [1, 0, 0, 0, 0, 0, 0, 1],
      [0, 1, 0, 0, 0, 0, 1, 0],
    ],
  },
  {
    // Middle rows - Crab type (medium points)
    key: 'invader_crab',
    color: 0x00ffff,
    points: 20,
    width: 44,
    height: 32,
    pattern1: [
      [0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0],
      [0, 1, 1, 0, 1, 1, 1, 0, 1, 1, 0],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1],
      [1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1],
      [0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0],
    ],
    pattern2: [
      [0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0],
      [1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 1],
      [1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1],
      [1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0],
      [0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0],
      [0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0],
    ],
  },
  {
    // Bottom rows - Octopus type (lowest points)
    key: 'invader_octopus',
    color: 0x00ff00,
    points: 10,
    width: 48,
    height: 32,
    pattern1: [
      [0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0],
      [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0],
      [0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 0],
      [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
    ],
    pattern2: [
      [0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0],
      [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [1, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 1],
      [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      [0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0],
      [0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0],
      [0, 0, 1, 1, 0, 0, 0, 0, 1, 1, 0, 0],
    ],
  },
]

// Alien/Invader grid configuration
export const ALIEN_CONFIG = {
  rows: 5,
  cols: 11,
  width: 40,
  height: 32,
  horizontalSpacing: 55,
  verticalSpacing: 45,
  startX: 80,
  startY: 120,
  initialSpeed: 30,
  speedIncrease: 5,
  dropDistance: 30,
  shootInterval: { min: 1000, max: 3000 },
  // Map rows to invader types (index into INVADER_TYPES)
  rowTypes: [0, 1, 1, 2, 2], // squid, crab, crab, octopus, octopus
  animationSpeed: 500, // ms between animation frames
}

// Bullet configuration
export const BULLET_CONFIG = {
  playerBullet: {
    width: 4,
    height: 15,
    speed: 500,
    color: 0x00ff00,
    cooldown: 300,
  },
  alienBullet: {
    width: 4,
    height: 15,
    speed: 250,
    color: 0xff0000,
  },
}

// UI configuration
export const UI_CONFIG = {
  fontSize: {
    title: '28px',
    score: '20px',
    gameOver: '48px',
    instructions: '18px',
  },
  colors: {
    primary: '#00ff00',
    danger: '#ff0000',
    white: '#ffffff',
  },
  scorePosition: { x: 10, y: 10 },
  livesPosition: { x: GAME_WIDTH - 10, y: 10 },
  titlePosition: { x: GAME_WIDTH / 2, y: 30 },
}

// Power-up configuration
export const POWERUP_CONFIG = {
  // Spawn settings
  baseSpawnChance: 0.15, // 15% base chance when alien dies
  maxActivePowerUps: 3, // Max different power-ups active at once
  fallSpeed: 80, // How fast power-ups fall

  // Power-up definitions
  types: {
    rapid_fire: {
      name: 'Rapid Fire',
      description: 'Faster shooting',
      duration: 8000,
      color: 0xff6600, // Orange
      spawnChance: 0.25,
      icon: '⚡',
      cooldownMultiplier: 0.4, // 60% faster shooting
    },
    shield: {
      name: 'Shield',
      description: 'Blocks one hit',
      duration: 10000,
      color: 0x00aaff, // Cyan
      spawnChance: 0.15,
      icon: '🛡',
      maxHits: 1,
    },
    multi_shot: {
      name: 'Multi-Shot',
      description: 'Triple bullets',
      duration: 7000,
      color: 0xff00ff, // Magenta
      spawnChance: 0.2,
      icon: '◈',
      bulletCount: 3,
      spreadAngle: 15, // Degrees
    },
    slow_motion: {
      name: 'Slow Motion',
      description: 'Slows enemies',
      duration: 6000,
      color: 0x00ff88, // Teal
      spawnChance: 0.2,
      icon: '◎',
      speedMultiplier: 0.5, // 50% enemy speed
    },
    score_multiplier: {
      name: 'Score x2',
      description: 'Double points',
      duration: 10000,
      color: 0xffff00, // Yellow
      spawnChance: 0.2,
      icon: '★',
      multiplier: 2,
    },
  },

  // Visual settings
  size: 24, // Power-up sprite size
  pulseSpeed: 1.5, // Animation pulse frequency
  glowIntensity: 0.8,
}

// Dynamic difficulty configuration
export const DIFFICULTY_CONFIG = {
  // Performance metrics weights for skill calculation
  weights: {
    accuracy: 0.35, // How often shots hit
    survivalTime: 0.25, // How long player survives
    scorePerMinute: 0.25, // Score efficiency
    aliensDestroyedRatio: 0.15, // How many aliens killed before death
  },

  // Skill level thresholds (0-100 scale)
  skillLevels: {
    beginner: { min: 0, max: 30 },
    intermediate: { min: 30, max: 60 },
    advanced: { min: 60, max: 80 },
    expert: { min: 80, max: 100 },
  },

  // Difficulty multipliers by skill level
  // Values > 1 make the game harder, < 1 make it easier
  modifiers: {
    beginner: {
      alienSpeed: 0.7,
      alienShootIntervalMultiplier: 1.4, // Slower shooting
      alienBulletSpeed: 0.75,
      playerBulletCooldown: 0.8, // Faster player shooting
    },
    intermediate: {
      alienSpeed: 1.0,
      alienShootIntervalMultiplier: 1.0,
      alienBulletSpeed: 1.0,
      playerBulletCooldown: 1.0,
    },
    advanced: {
      alienSpeed: 1.2,
      alienShootIntervalMultiplier: 0.8, // Faster alien shooting
      alienBulletSpeed: 1.15,
      playerBulletCooldown: 1.1,
    },
    expert: {
      alienSpeed: 1.4,
      alienShootIntervalMultiplier: 0.6, // Much faster alien shooting
      alienBulletSpeed: 1.3,
      playerBulletCooldown: 1.2,
    },
  },

  // Adaptive adjustment settings
  adaptation: {
    // How quickly difficulty adjusts mid-game (0-1, higher = faster)
    adjustmentRate: 0.15,
    // Minimum games before profile stabilizes
    gamesForStableProfile: 5,
    // Performance window for calculating running metrics
    recentGamesWindow: 10,
  },

  // Local storage key for player skill profile
  storageKey: 'space_invaders_2030_skill_profile',
}

export const GameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  parent: 'game-container',
  backgroundColor: '#000000',
  pixelArt: true,
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    min: {
      width: 400,
      height: 300,
    },
    max: {
      width: 1600,
      height: 1200,
    },
  },
  render: {
    antialias: false,
    pixelArt: true,
    roundPixels: true,
  },
}
